export default __webpack_public_path__ + "static/media/google-satellite.17953d46.PNG";